<template>
  <div class="Kanit">
    <v-container>
      <div
        v-if="$store.state.redirect"
        style="position: absolute; top: 15px; left: 10px"
      >
        <v-btn @click="query.view = $store.state.redirect" text class="pl-0">
          <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
        </v-btn>
      </div>
      <ValidationObserver ref="observer" tag="form">
        <form>
          <div class="text-center pt-6">
            <h2 style="margin-bottom: 15px">อัพรูปบิลสินค้า</h2>
          </div>
          <div class="mb-5">
            <div style="color: red">*ถ่ายรูปบิลสินค้าที่ท่านซื้อ</div>
            <div style="line-height: 18px">
              โปรดถ่ายรูปบิลสินค้าที่ท่านซื้ออย่างชัดเจน
              พร้อมระบุราคารวมสินค้าตามบิลที่ท่านแนบมาคะ
            </div>
          </div>
          <div>
            <ValidationProvider
              v-slot="{ errors }"
              name="รูปบิลสินค้า"
              rules="required"
              key="total"
            >
              <UploadSingleFile
                v-model="input.bill"
                :error-messages="errors"
                :background="require('../assets/billimg.jpg')"
              ></UploadSingleFile>
            </ValidationProvider>
          </div>
          <div class="pt-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="ราคารวมสินค้า"
              rules="required"
              key="total"
            >
              <v-text-field
                outlined
                name="total"
                type="number"
                :error-messages="errors"
                placeholder="กรอกราคารวมสินค้าตามบิล"
                v-model="input.total"
                style="border-radius: 12px"
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    ราคารวมสินค้า
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="ร้านค้าที่ท่านซื้อ"
              rules="required"
              key="store"
            >
              <v-text-field
                outlined
                :error-messages="errors"
                name="store"
                placeholder="กรอกร้านค้าที่ท่านซื้อ"
                v-model="input.store"
                style="border-radius: 12px"
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    ร้านค้าที่ท่านซื้อ
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <div
              @click="confirmData"
              v-ripple
              class="addcartbtn Kanit myshadow"
            >
              <p v-if="!saveloading">ยืนยันข้อมูล</p>
              <div v-else>
                <v-progress-circular
                  indeterminate
                  size="35"
                  color="white"
                ></v-progress-circular>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import axios from "axios";
export default {
  components: {
    UploadSingleFile,
  },
  data() {
    return {
      input: {
        total: "",
        store: "",
        bill: "",
      },
      saveloading: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    async confirmData() {
      if (!this.saveloading) {
        var isValid = await this.$refs.observer.validate();
        if (isValid) {
          var vm = this;
          var data = {
            userid: vm.$store.state.userid,
            apptype: vm.query.apptype,
            pageid: this.query.pageid,
            orderid: this.query.orderid,
            bill: this.input.bill,
            shopname: this.input.store,
            total: this.input.total,
          };
          this.saveloading = true;
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toapainteruploadbill",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              this.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              }
              if (response.data.responsecode == 200) {
                await this.$swal.fire({
                  icon: "success",
                  text: "สำเร็จ",
                });
                if (this.$store.state.redirect) {
                  this.query.view = this.$store.state.redirect;
                } else {
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                }
              } else {
                await this.$swal.fire({
                  icon: "error",
                  text: `Error code: ${response.data.responsecode}, ${response.data.reason}`,
                });
              }
            });
        }
      }
    },
  },
};
</script>
